export default "__VITE_ASSET__ChGNEpyX__"